/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavHolding = {
  fund_id: number | null;
  fund_name: string;
  security_id: number | null;
  security_name: string;
  /**
   * Weighted share value on the opening (pinned) valuation; null when added.
   */
  previous_share_value: number | null;
  /**
   * Weighted share value on today's valuation (Today's Price); null when removed, unpriced, or while the review is pending.
   */
  todays_share_value: number | null;
  /**
   * 'added': only on today's valuation. 'removed': only on the opening one. Null when on both, or while Today's Price is withheld.
   */
  holding_change: DailyNavHolding.holding_change | null;
};
export namespace DailyNavHolding {
  /**
   * 'added': only on today's valuation. 'removed': only on the opening one. Null when on both, or while Today's Price is withheld.
   */
  export enum holding_change {
    ADDED = 'added',
    REMOVED = 'removed',
  }
}

